<template>
  <div class="admin-room-container figma-property-page">
    <!-- 主列表页 -->
    <div class="figma-white-card" v-if="!showRecycle">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('richText.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="_addRow">
              <i class="el-icon-plus"></i>{{ $t('richText.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-recycle" @click="_goRecycle">
              <i class="el-icon-delete"></i>{{ $t('richText.action.recycle') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.name"
              :placeholder="$t('richText.search.keywordPlaceholder')" class="figma-search-input" clearable />
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :fit="true" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="rtId" :label="$t('richText.table.id')" min-width="128">
            <template slot-scope="scope">{{ scope.row.rtId || '-' }}</template>
          </el-table-column>
          <el-table-column prop="title" :label="$t('richText.table.title')" min-width="240">
            <template slot-scope="scope"><span class="figma-community-name">{{ scope.row.title || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('richText.table.createTime')" min-width="180" align="center">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="operateTime" :label="$t('richText.table.updateTime')" min-width="180" align="center">
            <template slot-scope="scope">{{ scope.row.operateTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" min-width="150" align="center">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="_editRow(scope.row)">{{ $t('richText.action.edit') }}</a>
                <span class="link-separator"></span>
                <a class="action-link action-link-danger" @click="_deleteRow(scope.row)">{{ $t('richText.action.delete') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size" layout="prev, pager, next, jumper" :total="pagination.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select">
          <el-option label="10条/页" :value="10" /><el-option label="20条/页" :value="20" /><el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <!-- 回收站页面 -->
    <div class="figma-white-card" v-else>
      <div class="figma-page-header">
        <div class="recycle-breadcrumb">
          <span class="recycle-breadcrumb-parent" @click="_backToList">{{ $t('richText.pageTitle') }}</span>
          <span class="recycle-breadcrumb-arrow">></span>
          <span class="recycle-breadcrumb-current">{{ $t('richText.action.recycle') }}</span>
        </div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-restore-all" @click="_restoreAll">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: -2px; margin-right: 4px;">
                <path d="M3.14844 8C3.14844 8.9889 3.44168 9.9556 3.99109 10.7778C4.5405 11.6001 5.32139 12.241 6.23502 12.6194C7.14865 12.9978 8.15398 13.0969 9.12389 12.9039C10.0938 12.711 10.9847 12.2348 11.684 11.5355C12.3832 10.8363 12.8594 9.94535 13.0524 8.97545C13.2453 8.00555 13.1463 7.00021 12.7678 6.08658C12.3894 5.17295 11.7485 4.39206 10.9263 3.84265C10.104 3.29324 9.13734 3 8.14844 3C6.75063 3.00526 5.40898 3.55068 4.40399 4.52222L3.14844 5.77778" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.14844 3V6H6.14844" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('richText.action.restoreAll') }}
            </el-button>
            <el-button size="small" class="figma-btn-clear-recycle" @click="_clearRecycle">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: -2px; margin-right: 4px;">
                <path d="M2 4H14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.6673 4V13.3333C12.6673 14 12.0007 14.6667 11.334 14.6667H4.66732C4.00065 14.6667 3.33398 14 3.33398 13.3333V4" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.33398 4.00065V2.66732C5.33398 2.00065 6.00065 1.33398 6.66732 1.33398H9.33398C10.0007 1.33398 10.6673 2.00065 10.6673 2.66732V4.00065" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.66602 7.33398V11.334" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.33398 7.33398V11.334" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('richText.action.clearRecycle') }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="recycleData" style="width: 100%" :fit="true" :header-cell-style="recycleHeaderCellStyle" :cell-style="recycleCellStyle">
          <el-table-column prop="rtId" :label="$t('richText.table.id')" min-width="160">
            <template slot-scope="scope">{{ scope.row.rtId || '-' }}</template>
          </el-table-column>
          <el-table-column prop="title" :label="$t('richText.table.title')" min-width="240">
            <template slot-scope="scope">{{ scope.row.title || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('richText.table.createTime')" min-width="180" align="center">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" min-width="150" align="center">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="_restoreRow(scope.row)">{{ $t('richText.action.restore') }}</a>
                <span class="link-separator"></span>
                <a class="action-link action-link-danger" @click="_permanentDeleteRow(scope.row)">{{ $t('richText.action.permanentDelete') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px" custom-class="figma-dialog" :close-on-click-modal="false">
      <div class="figma-dialog-header-bar"></div>
      <el-form ref="editForm" :model="editForm" label-width="100px" class="figma-dialog-form">
        <el-form-item :label="$t('richText.table.title') + ':'" required>
          <el-input v-model="editForm.title" :placeholder="$t('richText.audit.titlePlaceholder')" size="small" class="figma-dialog-input" />
        </el-form-item>
        <el-form-item :label="$t('richText.table.content') + ':'" required>
          <rich-text-editor ref="editor" v-model="editForm.content" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="figma-dialog-footer">
        <el-button size="small" class="figma-btn-cancel" @click="dialogVisible = false">{{ $t('richText.audit.cancel') }}</el-button>
        <el-button size="small" class="figma-btn-confirm" @click="_submitForm">{{ $t('richText.audit.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRichText, deleteRichText, saveRichText, updateRichText, listRecycleRichText, restoreRichText, batchRestoreRichText, removeRichText, cleanRecycleRichText } from '@/api/platform/platformApi'
import RichTextEditor from '@/components/editor/RichTextEditor.vue'

export default {
  name: 'RichTextList',
  components: { RichTextEditor },
  data() {
    return {
      conditions: { name: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editForm: { rtId: '', title: '', content: '' },
      showRecycle: false,
      recycleData: []
    }
  },
  created() {
    this._listData(this.pagination.current, this.pagination.size)
  },
  methods: {
    _listData(page, size) {
      listRichText({ ...this.conditions, page, row: size }).then(res => {
        this.tableData = Array.isArray(res.data) ? res.data : []
        this.pagination.total = res.total || 0
      }).catch(error => { console.error('请求失败处理', error) })
    },
    _queryMethod() {
      this.pagination.current = 1
      this._listData(this.pagination.current, this.pagination.size)
    },
    _addRow() {
      this.isEdit = false
      this.dialogTitle = this.$t('richText.action.add')
      this.editForm = { rtId: '', title: '', content: '' }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.clear()
      })
    },
    _editRow(row) {
      this.isEdit = true
      this.dialogTitle = this.$t('richText.action.edit')
      this.editForm = { rtId: row.rtId, title: row.title, content: row.content || '' }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.setContent(this.editForm.content)
      })
    },
    _deleteRow(row) {
      this.$confirm(this.$t('richText.audit.deleteConfirm'), this.$t('richText.audit.deleteTitle'), {
        confirmButtonText: this.$t('richText.action.delete'),
        cancelButtonText: this.$t('richText.audit.cancel'),
        type: 'warning'
      }).then(() => {
        deleteRichText({ rtId: row.rtId }).then(() => {
          this.$message.success(this.$t('richText.audit.deleteSuccess'))
          this._queryMethod()
        }).catch(error => { console.error('删除失败', error) })
      }).catch(() => {})
    },
    _goRecycle() {
      listRecycleRichText({ page: 1, row: 100 }).then(res => {
        this.recycleData = Array.isArray(res.data) ? res.data : []
        this.showRecycle = true
      }).catch(error => { console.error('获取回收站列表失败', error) })
    },
    _backToList() {
      this.showRecycle = false
      this._queryMethod()
    },
    _restoreRow(row) {
      restoreRichText({ rtId: row.rtId }).then(() => {
        this.$message.success(this.$t('richText.audit.restoreSuccess'))
        this._loadRecycleData()
        this._queryMethod()
      }).catch(error => { console.error('还原失败', error) })
    },
    _permanentDeleteRow(row) {
      this.$confirm(this.$t('richText.audit.permanentDeleteConfirm'), this.$t('richText.audit.deleteTitle'), {
        confirmButtonText: this.$t('richText.action.permanentDelete'),
        cancelButtonText: this.$t('richText.audit.cancel'),
        type: 'warning'
      }).then(() => {
        removeRichText({ rtId: row.rtId }).then(() => {
          this.$message.success(this.$t('richText.audit.deleteSuccess'))
          this._loadRecycleData()
        }).catch(error => { console.error('删除失败', error) })
      }).catch(() => {})
    },
    _restoreAll() {
      if (!this.recycleData.length) {
        this.$message.info(this.$t('richText.audit.noData'))
        return
      }
      this.$confirm(this.$t('richText.audit.restoreAllConfirm'), this.$t('richText.audit.deleteTitle'), {
        confirmButtonText: this.$t('richText.action.restoreAll'),
        cancelButtonText: this.$t('richText.audit.cancel'),
        type: 'warning'
      }).then(() => {
        const rtIds = this.recycleData.map(row => row.rtId)
        batchRestoreRichText({ rtIds }).then(() => {
          this.$message.success(this.$t('richText.audit.restoreSuccess'))
          this._loadRecycleData()
          this._queryMethod()
        }).catch(error => { console.error('还原失败', error) })
      }).catch(() => {})
    },
    _clearRecycle() {
      if (!this.recycleData.length) {
        this.$message.info(this.$t('richText.audit.noData'))
        return
      }
      this.$confirm(this.$t('richText.audit.clearRecycleConfirm'), this.$t('richText.audit.deleteTitle'), {
        confirmButtonText: this.$t('richText.action.clearRecycle'),
        cancelButtonText: this.$t('richText.audit.cancel'),
        type: 'warning'
      }).then(() => {
        cleanRecycleRichText({}).then(() => {
          this.$message.success(this.$t('richText.audit.clearSuccess'))
          this.recycleData = []
          this._queryMethod()
        }).catch(error => { console.error('清空失败', error) })
      }).catch(() => {})
    },
    _loadRecycleData() {
      listRecycleRichText({ page: 1, row: 100 }).then(res => {
        this.recycleData = Array.isArray(res.data) ? res.data : []
      }).catch(error => { console.error('获取回收站列表失败', error) })
    },
    _submitForm() {
      if (!this.editForm.title) {
        this.$message.warning(this.$t('richText.audit.titleRequired'))
        return
      }
      const api = this.isEdit ? updateRichText : saveRichText
      api(this.editForm).then(() => {
        this.$message.success(this.$t('richText.audit.saveSuccess'))
        this.dialogVisible = false
        this._queryMethod()
      }).catch(error => { console.error('保存失败', error) })
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this._listData(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listData(val, this.pagination.size)
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
        : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
    },
    recycleHeaderCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC' }
    },
    recycleCellStyle({ row }) {
      const rowIndex = this.recycleData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
        : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 8px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 16px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-add { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-recycle { height: 38px; border-radius: 10px !important; background: rgba(14, 118, 255, 0.14) !important; border: none !important; color: #0E76FF !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 1; padding: 0 24px; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section >>> .el-table__body td { border: none !important; border-bottom: 1px solid #F0F0F0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF; }
.figma-community-name { color: #0E76FF; font-weight: 500; }
.action-links { display: flex; align-items: center; justify-content: center; gap: 8px; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link-danger { color: #FB2C36; }
.link-separator { color: #DCE6F5; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px; gap: 16px; border-top: 1px solid #DCE6F5; }
.pagination-total { font-size: 14px; color: #1D2129; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; }
.figma-pagination >>> .el-pager li { border-radius: 8px; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; }
.pagination-size-select >>> .el-input__inner { border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; }

/* Dialog styles */
.figma-dialog >>> .el-dialog { border-radius: 12px; overflow: hidden; }
.figma-dialog >>> .el-dialog__header { background: #EBF2FA; padding: 22px 24px; }
.figma-dialog >>> .el-dialog__title { font-size: 16px; font-weight: 600; color: #1D2129; }
.figma-dialog-header-bar { height: 1px; background: #DCE6F5; margin: -20px -20px 20px; }
.figma-dialog-form { padding: 20px 0; }
.figma-dialog-form >>> .el-form-item__label { font-size: 14px; color: #1D2129; font-weight: 500; }
.figma-dialog-input >>> .el-input__inner { border-radius: 10px; border: 1px solid #DCE6F5; height: 38px; }
.figma-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.figma-btn-cancel { height: 38px; border-radius: 10px !important; border: 1px solid #0E76FF !important; background: white !important; color: #0E76FF !important; font-size: 14px; font-weight: 500; padding: 0 24px; }
.figma-btn-confirm { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 24px; }

/* Recycle page styles */
.recycle-breadcrumb { display: flex; align-items: center; font-size: 16px; font-weight: 600; font-family: 'PingFang SC'; }
.recycle-breadcrumb-parent { color: #8C9BB4; cursor: pointer; }
.recycle-breadcrumb-parent:hover { color: #0E76FF; }
.recycle-breadcrumb-arrow { margin: 0 8px; color: #8C9BB4; }
.recycle-breadcrumb-current { color: #1D2129; }
.figma-btn-restore-all { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-restore-all:hover { background: #0A6AE5 !important; }
.figma-btn-clear-recycle { height: 38px; border-radius: 10px !important; background: #FB2C36 !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-clear-recycle:hover { background: #E02730 !important; }
</style>
